class ValidationHelper {
    static isValidEmail(email) {
        if (!email || typeof email !== 'string') {
            return false;
        }
        const trimmed = email.trim();
        if (trimmed.toLowerCase().startsWith('mailto:')) {
            return false;
        }
        // https://www.w3.org/TR/2012/WD-html-markup-20120329/input.email.html
        const regex = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);
        return regex.test(trimmed);
    }

    static sanitizeEmail(email) {
        if (!email || typeof email !== 'string') {
            return email;
        }
        let sanitized = email.trim();
        // Note: We intentionally do NOT strip 'mailto:' prefix here.
        // Emails with 'mailto:' prefix should be rejected by validation,
        // not silently sanitized, so users get proper feedback.
        sanitized = sanitized.replace(/[\r\n]/g, '');
        return sanitized.trim();
    }
}
export default ValidationHelper;
